import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { bookingPaymentsService } from "@/services/booking-payments-service";
import type { TopUpGuestWalletPayload } from "@/types/booking-payments";
import { billingTransactionKeys } from "./useBillingTransactions";

export const bookingPaymentKeys = {
  all: ["bookingPayments"] as const,
  summaries: () => [...bookingPaymentKeys.all, "summary"] as const,
  summary: (bookingId?: string) =>
    [...bookingPaymentKeys.summaries(), bookingId] as const,
};

export const useBookingPaymentSummary = (bookingId?: string) => {
  return useQuery({
    queryKey: bookingPaymentKeys.summary(bookingId),
    queryFn: () => bookingPaymentsService.getBookingPaymentSummary(bookingId!),
    enabled: Boolean(bookingId),
    staleTime: 60 * 1000,
  });
};

export const useTopUpGuestWallet = (bookingId?: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: TopUpGuestWalletPayload) => {
      if (!bookingId) {
        throw new Error("Booking ID is required");
      }

      return bookingPaymentsService.topUpGuestWallet(bookingId, payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: bookingPaymentKeys.summary(bookingId),
      });
      queryClient.invalidateQueries({
        queryKey: billingTransactionKeys.all,
      });
    },
  });
};
